import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone';
import autobind from 'autobind-decorator';

@inject('songsStore')
@observer
class SongUpload extends Component {
	componentDidMount () {
		this.props.songsStore.currentUploadProgress = 0;
	}

	render () {
		const { songsStore, onDrop = this.onDrop, fullWidth = false } = this.props;

		if (songsStore.isUpLoading) {

			return (
				<div className="grid-x align-center">
					<div className="cell padding-top-2">
						Uploading...
					</div>
				</div>
			);
		}

		return (
			<div>
				<div className="dropzone">
					<Dropzone onDrop={ onDrop } className={ `drop-zone${ fullWidth ? ' full-width' : '' }` }>
						{/* <span className="fas fa-music"></span>
						<br />
						<strong>
							Drag &amp; drop your .mp3 or .wav files
							<br />
							or click here.
						</strong> */}
						{
					() => (
						<Fragment>
							<span className="fas fa-music"></span>
							<br />
							<strong>
								Drag &amp; drop your .mp3 or .wav files
								<br />
								or click here.
							</strong>
						</Fragment>
					)
				}
					</Dropzone>
				</div>
			</div>
		);
	}

	@autobind
	onDrop (files) {
		const { songsStore, onUpload = () => {} } = this.props;
		this.props.songsStore.uploadSongs(files);
		onUpload();
	}
}

export default SongUpload;
